import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const IssueDuplicateIcon = forwardRef<SVGSVGElement, Props>(
	(props, ref) => {
		return (
			<svg
				viewBox="0 0 14 14"
				xmlns="http://www.w3.org/2000/svg"
				ref={ref}
				fill="none"
				{...props}
			>
				<mask id="issue-duplicate-slash-mask">
					<rect width="14" height="14" fill="white" />
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						fill="black"
						d="M9.5791 5.71973C9.872 5.42684 10.3468 5.42686 10.6396 5.71973C10.9325 6.01262 10.9325 6.48738 10.6396 6.78027L6.78027 10.6396C6.48738 10.9325 6.01262 10.9325 5.71973 10.6396C5.42686 10.3468 5.42684 9.872 5.71973 9.5791L9.5791 5.71973ZM7.21973 3.36035C7.51261 3.06746 7.98738 3.06747 8.28027 3.36035C8.57315 3.65325 8.57316 4.12801 8.28027 4.4209L4.4209 8.28027C4.12801 8.57316 3.65325 8.57315 3.36035 8.28027C3.06747 7.98738 3.06746 7.51261 3.36035 7.21973L7.21973 3.36035Z"
					/>
				</mask>
				<circle
					cx="7"
					cy="7"
					r="6"
					fill={props.color || "currentColor"}
					mask="url(#issue-duplicate-slash-mask)"
				/>
			</svg>
		)
	},
)
